import { onMounted, onUnmounted } from "vue";

/**
 * Resets scroll to the top and takes manual control of the browser's native scroll
 * restoration for the lifetime of the component. Use on pages whose content is (re)loaded
 * asynchronously after mount (e.g. after a redirect, or on back/forward navigation), so the
 * user is never stranded at a stale scroll position — typically at the footer — while the
 * real content above is still loading in.
 */
export function useScrollResetOnMount(): void {
    const supportsScrollRestoration = "scrollRestoration" in window.history;

    onMounted(() => {
        if (supportsScrollRestoration) {
            window.history.scrollRestoration = "manual";
        }
        window.scrollTo(0, 0);
    });

    onUnmounted(() => {
        if (supportsScrollRestoration) {
            window.history.scrollRestoration = "auto";
        }
    });
}
